import { render, staticRenderFns } from "./AddImgProduct.vue?vue&type=template&id=63975f3a&scoped=true"
import script from "./AddImgProduct.vue?vue&type=script&lang=js"
export * from "./AddImgProduct.vue?vue&type=script&lang=js"
import style0 from "./AddImgProduct.vue?vue&type=style&index=0&id=63975f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63975f3a",
  null
  
)

export default component.exports